import { get } from "lodash";
import { useCallback } from "react";
import { useFormState } from "react-final-form";
import { usePermissions } from "ra-core";

const WILDCARD_STATES = [
  "draft",
  "integrations_requested",
  "documentation_1_sent_integrations",
  "documentation_2_sent_integrations",
  "documentation_3_sent_integrations",
];
const WILDCARD_FIELDS = ["project_docs", "project_media"];

const useFormPermission = (roles = ["admin"]) => {
  const formState = useFormState();
  const formPermissions = get(formState.values, "permissions", []);
  const transactionState = get(formState.values, "transaction.state", "draft");
  const { loaded, permissions } = usePermissions();
  const isAdmin = loaded && permissions && permissions(roles);

  return useCallback(
    (permissionName) => {
      const hasPermission =
        isAdmin ||
        ((formPermissions.length === 0 ||
          formPermissions.find((p) => p.name === permissionName) !==
            undefined) &&
          WILDCARD_STATES.indexOf(transactionState) !== -1) ||
        (WILDCARD_FIELDS.indexOf(permissionName) !== -1 &&
          WILDCARD_STATES.indexOf(transactionState) === -1);

      return hasPermission;
    },
    [formPermissions, isAdmin, transactionState]
  );
};

export default useFormPermission;
